<div class="row pb-2">
  <div class="col-12 ps-4">
    <nb-radio-group
      name="energyOrCarbonTrajectoryFilter"
      class="filters-container"
      [(ngModel)]="filterValue"
      (click)="filterValueChanged()"
      >
      @for (option of options; track option.value) {
        <nb-radio [value]="option.value">
          <span [innerHTML]="option.label | translate"></span>
        </nb-radio>
      }
    </nb-radio-group>
  </div>
</div>
